import script from "./Rulls.vue?vue&type=script&setup=true&lang=js"
export * from "./Rulls.vue?vue&type=script&setup=true&lang=js"

import "./Rulls.vue?vue&type=style&index=0&id=8592b014&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8592b014"]])

export default __exports__